export type SparkAdsFeaturs = [
  { feature: 'Sending Briefs with Spark Ads', errorMessage: string },
];

export const composeSparkAdsFeatures = (): SparkAdsFeaturs => [{
    feature: 'Sending Briefs with Spark Ads',
    errorMessage: '',
}];
